import { render } from "./Dictionary.vue?vue&type=template&id=7ecc28ee&scoped=true"
import script from "./Dictionary.vue?vue&type=script&lang=js"
export * from "./Dictionary.vue?vue&type=script&lang=js"

import "./Dictionary.vue?vue&type=style&index=0&id=7ecc28ee&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/toki-pona-translator/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ecc28ee"]])

export default __exports__